import { useAdminCargoDetailPageProps } from "./fetch";
import { AdminCargoDetailPageUi } from "./ui";

export const AdminCargoDetailPage: React.FC<{
  cargoIdStr?: string;
}> = ({ cargoIdStr }) => {
  const props = useAdminCargoDetailPageProps(cargoIdStr);
  return <AdminCargoDetailPageUi {...props} />;
};
